import {
  faAt,
  faCheck,
  faCalendar,
  faChevronDown,
  faHeading,
  faLocationDot,
  faParagraph,
  faPhone,
  faRectangle,
  faText,
  IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getFormBuilderItemKindKey, TFormBuilderItemKindKey } from "../../model/item/formBuilderItem";

export interface IFormBuilderItemMetadata {
  label: string;
  icon: IconDefinition;
  unique: boolean;
}

type TFormBuilderItemMetadataMap = Map<TFormBuilderItemKindKey, IFormBuilderItemMetadata>;

export function useFormBuilderItemMetadataMap(): TFormBuilderItemMetadataMap {
  const { t } = useTranslation();

  const metadataMap = useMemo<TFormBuilderItemMetadataMap>(() => {
    return new Map<TFormBuilderItemKindKey, IFormBuilderItemMetadata>([
      [
        getFormBuilderItemKindKey("button", "reset"),
        { label: t("Reset"), icon: faRectangle, unique: true },
      ],
      [
        getFormBuilderItemKindKey("button", "submit"),
        { label: t("Submit"), icon: faRectangle, unique: true },
      ],
      [
        getFormBuilderItemKindKey("checkbox", "custom"),
        { label: t("Checkbox"), icon: faCheck, unique: false },
      ],
      [
        getFormBuilderItemKindKey("date", "custom"),
        { label: t("Date"), icon: faCalendar, unique: false },
      ],
      [
        getFormBuilderItemKindKey("input", "address"),
        { label: t("Address"), icon: faLocationDot, unique: true },
      ],
      [
        getFormBuilderItemKindKey("input", "custom"),
        { label: t("Input"), icon: faText, unique: false },
      ],
      [
        getFormBuilderItemKindKey("input", "email"),
        { label: t("Email"), icon: faAt, unique: true },
      ],
      [
        getFormBuilderItemKindKey("input", "first-name"),
        { label: t("First name"), icon: faText, unique: true },
      ],
      [
        getFormBuilderItemKindKey("input", "last-name"),
        { label: t("Last name"), icon: faText, unique: true },
      ],
      [
        getFormBuilderItemKindKey("input", "phone"),
        { label: t("Phone"), icon: faPhone, unique: true },
      ],
      [
        getFormBuilderItemKindKey("select", "custom"),
        { label: t("Select"), icon: faChevronDown, unique: false },
      ],
      [
        getFormBuilderItemKindKey("select", "inquiry"),
        { label: t("Inquiry"), icon: faChevronDown, unique: true },
      ],
      [
        getFormBuilderItemKindKey("text", "heading"),
        { label: t("Heading"), icon: faHeading, unique: false },
      ],
      [
        getFormBuilderItemKindKey("text", "paragraph"),
        { label: t("Paragraph"), icon: faParagraph, unique: false },
      ],
      [
        getFormBuilderItemKindKey("textarea", "custom"),
        { label: t("Textarea"), icon: faText, unique: false },
      ],
      [
        getFormBuilderItemKindKey("textarea", "message"),
        { label: t("Message"), icon: faText, unique: true },
      ],
    ]);
  }, []);

  return metadataMap;
}